module.exports = __webpack_public_path__ + "static/media/basque-country.2b84f87a.svg";